
import { decodeClientData } from '../../../core/js/utils/decodeUtils';

export const helpInitialState = decodeClientData(window.helpData);

export default helpInitialState;
